import "../styles/howto.scss";
import { useNavigate } from "react-router-dom";

export default function HowTo() {
  const navigate = useNavigate();

  return (
    <section className="how__to" id="how">
      {/* <h2>how to enroll in the elite business mastermind</h2> */}
      <h2 className="how__to__headline">One Decision Can Change Everything</h2>
      <h2 className="how__to__headline">Take the First Step Today</h2>

      <hr />
      <section className="how__to__steps">
        <div className="how__to__step step__one">
          <div className="step__number">
            <p>01</p>
          </div>
          <div className="step__description">
            <h3>Apply Now</h3>
            <p>Click “Apply Now” and fill in a short form to tell us about you and your business. The more we know, the better we can support you.</p>
          </div>
        </div>
        <div className="how__to__step">
          <div className="step__number">
            <p>02</p>
          </div>
          <div className="step__description">
            <h3>Schedule Your Consultation</h3>
            <p>
              After applying, book a call with our team to chat about the Elite
              Business Mastermind. Ask questions, learn more, and see if it’s
              the right fit for you—no pressure, just a conversation.
            </p>
          </div>
        </div>
        <div className="how__to__step">
          <div className="step__number">
            <p>03</p>
          </div>
          <div className="step__description">
            <h3>Application Review</h3>
            <p>
              We’ll review your application and call. If the Mastermind is a
              good fit for your goals, we’ll invite you to join and guide you
              through the next steps.
            </p>
          </div>
        </div>
        <div className="how__to__step">
          <div className="step__number">
            <p>04</p>
          </div>
          <div className="step__description">
            <h3>Attend Live Events</h3>
            <p>
              Join four in-person mastermind sessions during the year to create
              your growth plan, solve challenges, and take your business to the
              next level. Plus, you’ll have monthly coaching and community
              support to keep you moving forward.
            </p>
          </div>
        </div>
      </section>
      <button
        className="how__btn"
        onClick={() => navigate("/register")}
        style={{ marginTop: "3%" }}
      >
        Apply Now
      </button>
    </section>
  );
}
